import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"

import { BACKEND_APIS } from "@constants"
import { slaveId } from "@signals/user"
import { getSubmit } from "@ui-seeker/utils"
import { useSignal } from '@preact/signals-react'


export default function SlavesAutocomplete() {

	const slave = useSignal(null)
	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		sx={{
			width: "200px",
			maxHeight: "30px",
			"& .MuiInputBase-root": {
				backgroundColor: "white",
				py: "3px !important"
			},
			"& .MuiOutlinedInput-root": {
				"& fieldset": {
					borderColor: "white",
				},
				"&:hover fieldset": {
					borderColor: "white",
				},
				"&.Mui-focused fieldset": {
					borderColor: "white",
				}
			},
			"& .MuiInputLabel-root": {
				color: "white",
			},
			"& .Mui-focused .MuiInputLabel-root": {
				color: "white",
			},
			"& .MuiFormHelperText-root": {
				color: "white",
			}
		}}
		filters={{
			selected: slave.value
		}}
		useLoading
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/report/options/slaves`}
		onFinishAjax={options => {
			const selectedOption = options.filter(({selected}) => selected)[0]
			if(selectedOption) slave.value = selectedOption.value
		}}
		placeholder="Employees"
		value={slave.value}
		disabled={false}
		onChange={e => {
			slave.value = e.target.value
			getSubmit(`${BACKEND_APIS.SESSION}/set-slave`, { uidSlave: e.target.value }).then(() => {
				window.location.reload()
			})
		}}
	/>
}